import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotifictChangeListService {

  private updateNotification = new Subject<void>();

  updateNotifications$ = this.updateNotification.asObservable();

  notificationUpdate(count: any){
    this.updateNotification.next(count);
  }

  constructor() { }
}
